"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const consts_1 = require("~/store/consts");
const UI_1 = require("~/components/UI");
const types_1 = require("~/store/types");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const react_i18next_1 = require("react-i18next");
const events_1 = require("~/consts/events");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("~/consts/routes");
const consts_2 = require("./consts");
const Viewer_1 = __importDefault(require("./Viewer"));
const Cad3d_scss_1 = __importDefault(require("./Cad3d.scss"));
const PopupEditable_1 = __importDefault(require("../UI/PopupEditable"));
const InformationBanner_1 = __importDefault(require("../UI/InformationBanner"));
const projectLoadingProgressByStage = {
    'project-data': 0,
    'models': 33,
    'connections': 67,
};
// eslint-disable-next-line react/function-component-definition
const Cad3d = ({ viewerRef, updateHistoryControls, modals }) => {
    var _a, _b, _c, _d;
    const selectedTool = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTool);
    const drawingAngled = (0, react_redux_1.useSelector)(selectors_1.selectDrawingAngled);
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const isProjectSharedWithAll = (0, react_redux_1.useSelector)(selectors_1.selectIsProjectSharedWithAll);
    const allSeriesMap = (0, react_redux_1.useSelector)(selectors_1.selectAllSeries);
    const catalogMeta = (0, react_redux_1.useSelector)(selectors_1.selectCatalogMeta);
    const projectLoadingState = (0, react_redux_1.useSelector)(selectors_1.selectProjectLoadingState);
    const projectLoadingStage = (0, react_redux_1.useSelector)(selectors_1.selectProjectLoadingStage);
    const catalogLoadingState = (0, react_redux_1.useSelector)(selectors_1.selectCatalogLoadingState);
    const projectItemsReplacementState = (0, react_redux_1.useSelector)(selectors_1.selectProjectItemsReplacementState);
    const { bom, isLoading: bomLoadingStatus } = (0, react_redux_1.useSelector)(selectors_1.selectBOM);
    const bomItemsCount = (0, react_redux_1.useSelector)(selectors_1.selectBOMItemsCount);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const { t } = (0, react_i18next_1.useTranslation)('cad3d');
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { pathname } = location;
    const selectedTransformMode = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTransformModes);
    const isDefaultFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.DEFAULT_FASTENER_WIDGET));
    const isCurrentFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.CURRENT_FASTENER_WIDGET));
    const isItemReplacementWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_1.WIDGETS.ITEM_REPLACEMENT_WIDGET));
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const defaultFasteners = (0, react_redux_1.useSelector)(selectors_1.selectProjectDefaultFasteners);
    const { dispatchSelectTool, dispatchTransformPanelTool, dispatchSelectItem, dispatchContextMenu, dispatchUpdateFastenersToBOM, dispatchSetProjectLoadingStage, } = (0, redux_1.bindActionCreators)({
        dispatchSelectTool: actions_1.selectTool,
        dispatchTransformPanelTool: actions_1.transformPanelTool,
        dispatchSelectItem: actions_1.selectItem,
        dispatchContextMenu: actions_1.toggleContextMenu,
        dispatchUpdateFastenersToBOM: actions_1.requestUpdateFastenersToBOM,
        dispatchSetProjectLoadingStage: actions_1.setProjectLoadingStage,
    }, (0, react_redux_1.useDispatch)());
    // methods for testing
    const [rotationSpeed, setRotationSpeed] = (0, react_1.useState)(consts_2.consts.CAMERA_OVER_POINT_ROTATION_SPEED);
    const [loadingModel, setLoadingModel] = (0, react_1.useState)(false);
    const [loadingProject, setLoadingProject] = (0, react_1.useState)(false);
    const [replacingProjectItems, setReplacingProjectItems] = (0, react_1.useState)(false);
    const [wsConnectionReestablishing, setWsConnectionReestablishing] = (0, react_1.useState)(false);
    const getPreferences = () => {
        var _a;
        const savedPreferences = localStorage.getItem('preferences');
        if (savedPreferences) {
            setRotationSpeed((_a = JSON.parse(savedPreferences)) === null || _a === void 0 ? void 0 : _a.rotationSpeed);
        }
    };
    const setContextMenu = (newAlignment) => {
        dispatchContextMenu(newAlignment);
    };
    const setSelectedTool = (newAlignment) => {
        dispatchSelectTool(newAlignment);
    };
    const setToolToDefault = () => {
        dispatchSelectTool(consts_1.TOOL_STATE.NAVIGATE);
    };
    const unselectCatalogItems = () => {
        dispatchSelectItem(null);
    };
    const setTransformToolToDefault = () => {
        dispatchTransformPanelTool(consts_1.TRANSFORM_MODE.NONE);
    };
    const setSelectedTransformTool = (newAlignment) => {
        dispatchTransformPanelTool(newAlignment);
    };
    const callUpdateFastenersToBOM = (fastenersData) => {
        dispatchUpdateFastenersToBOM(fastenersData);
    };
    const [sceneParams] = (0, react_1.useState)({
        sceneSize: consts_2.consts.DEFAULT_GRID_SIZE,
        gridCellsSize: consts_2.consts.DEFAULT_GRID_CELL_SIZE,
    });
    const handleWSConnectionStatus = (e) => {
        setWsConnectionReestablishing(e.detail.status === types_1.LOADING_STATE.WS_RECONNECTING || e.detail.status === types_1.LOADING_STATE.WS_CONNECTION_ERROR);
    };
    (0, react_1.useEffect)(() => {
        getPreferences();
    }, []);
    (0, react_1.useEffect)(() => {
        setLoadingProject(projectLoadingState === types_1.LOADING_STATE.LOADING);
    }, [projectLoadingState]);
    (0, react_1.useEffect)(() => {
        setReplacingProjectItems(projectItemsReplacementState === types_1.LOADING_STATE.LOADING);
    }, [projectItemsReplacementState]);
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_1.wsConnectionStatusChanged, handleWSConnectionStatus);
        return () => {
            document.body.removeEventListener(events_1.wsConnectionStatusChanged, handleWSConnectionStatus);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!user && !isProjectSharedWithAll && bomLoadingStatus === types_1.LOADING_STATE.COMPLETE && bomItemsCount >= 3) {
            navigate(routes_1.ROUTE_LOGIN, { replace: true });
        }
    }, [user, bomLoadingStatus, bomItemsCount]);
    const preloaderLabel = (0, react_1.useMemo)(() => {
        const preloaderLabelsKey = 'preloader-labels';
        if (loadingModel) {
            return t(`${preloaderLabelsKey}.loading-model`);
        }
        if (loadingProject) {
            return projectLoadingStage
                ? t(`${preloaderLabelsKey}.${projectLoadingStage}`)
                : t(`${preloaderLabelsKey}.opening-your-project`);
        }
        if (replacingProjectItems) {
            return t(`${preloaderLabelsKey}.replacing-project-items`);
        }
        if (wsConnectionReestablishing) {
            return t(`${preloaderLabelsKey}.reestabilishing-connection`);
        }
        return t(`${preloaderLabelsKey}.creating-your-project`);
    }, [loadingModel, loadingProject, projectLoadingStage, replacingProjectItems, t, wsConnectionReestablishing]);
    const showPreloader = loadingModel || loadingProject || replacingProjectItems || wsConnectionReestablishing;
    const showPreloaderOverlay = loadingProject || replacingProjectItems || wsConnectionReestablishing;
    const preloaderProgress = loadingProject
        ? projectLoadingProgressByStage[projectLoadingStage !== null && projectLoadingStage !== void 0 ? projectLoadingStage : 'project-data']
        : undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showPreloader && (react_1.default.createElement(UI_1.Preloader, { label: preloaderLabel, hasOverlay: showPreloaderOverlay, progress: preloaderProgress })),
        react_1.default.createElement(UI_1.Popup, { id: Cad3d_scss_1.default.lengthLabel }),
        react_1.default.createElement(UI_1.Popup, { id: Cad3d_scss_1.default.angleLabel }),
        react_1.default.createElement(PopupEditable_1.default, { id: Cad3d_scss_1.default.lengthEditableLabel }),
        pathname === '/' && react_1.default.createElement(InformationBanner_1.default, null),
        react_1.default.createElement(Viewer_1.default
        // eslint-disable-next-line no-return-assign, no-param-reassign
        , { 
            // eslint-disable-next-line no-return-assign, no-param-reassign
            ref: (ref) => (viewerRef.current = ref), sceneParams: sceneParams, selectedTool: selectedTool, selectedTransformMode: selectedTransformMode, setSelectedTool: setSelectedTool, setToolToDefault: setToolToDefault, setTransformToolToDefault: setTransformToolToDefault, setSelectedTransformTool: setSelectedTransformTool, setContextMenu: setContextMenu, updateHistoryControls: updateHistoryControls, setLoadingModel: setLoadingModel, setProjectLoadingStage: dispatchSetProjectLoadingStage, catalogLoadingState: catalogLoadingState, rotationSpeed: rotationSpeed, unselectCatalogItems: unselectCatalogItems, callUpdateFastenersToBOM: callUpdateFastenersToBOM, drawingAngled: drawingAngled, isFastenerWidgetShown: isDefaultFastenersWidgetShown || isCurrentFastenersWidgetShown, projectId: projectId, allSeriesMap: allSeriesMap, defaultProjectFasteners: defaultFasteners, catalogItems: (_a = window.data) !== null && _a !== void 0 ? _a : [], catalogMachiningServices: (_b = window.dataMS) !== null && _b !== void 0 ? _b : [], isOrderCompleted: isOrderCompleted, isProjectArchived: isProjectArchived, isProjectViewOnly: isProjectViewOnly, seriesTypes: (_d = (_c = catalogMeta === null || catalogMeta === void 0 ? void 0 : catalogMeta.data) === null || _c === void 0 ? void 0 : _c.seriesTypes) !== null && _d !== void 0 ? _d : [], bom: bom, user: user, modals: modals, isDefaultFastenersWidgetShown: isDefaultFastenersWidgetShown, isItemReplacementWidgetShown: isItemReplacementWidgetShown })));
};
exports.default = Cad3d;
